exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bsh-dropdown[data-v-cfc459c6]{background-color:#fff;padding:0;margin:0}.clickable[data-v-cfc459c6]{cursor:pointer}.dropdown-menu[data-v-cfc459c6]{overflow-y:auto;max-height:200px}", ""]);

// exports
